import * as React from "react";

import { reject } from "../../../../../../Common/TypingUtils";

import { IUserPicklistRegistry, UserPicklistRegistry } from "./UserPicklistRegistry";

const UserPicklistRegistryContext = React.createContext<IUserPicklistRegistry | undefined>(undefined);

export function useUserPicklistRegistry(): IUserPicklistRegistry {
    return (
        React.useContext(UserPicklistRegistryContext) ?? reject("Parent UserPicklistRegistryStorage is not provided")
    );
}

interface UserPicklistRegistryStorageProps {
    children: React.ReactNode;
}

export function UserPicklistRegistryStorage(props: UserPicklistRegistryStorageProps): JSX.Element {
    const registry = React.useMemo(() => new UserPicklistRegistry(), []);

    return (
        <UserPicklistRegistryContext.Provider value={registry}>{props.children}</UserPicklistRegistryContext.Provider>
    );
}
